// extracted by mini-css-extract-plugin
module.exports = {"content":"RichText_content__VIhc4"};